import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { auth } from '../firebase';
import { writeAuditLog } from '../utils/auditLog';

export default function LoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(''); setLoading(true);
    try {
      const cred = await signInWithEmailAndPassword(auth, email, password);
      const token = await cred.user.getIdTokenResult(true);
      const pharmacyId = token.claims.pharmacyId;
      if (pharmacyId) {
        await writeAuditLog(pharmacyId, cred.user, {
          action: 'Login success',
          entityType: 'auth',
          entityId: cred.user.uid,
          entityName: cred.user.email,
          actorRole: token.claims.role || '',
          source: 'client',
        });
      }
      navigate('/dashboard');
    } catch (err) {
      const msgs = {
        'auth/user-not-found': 'No account found with that email.',
        'auth/wrong-password': 'Incorrect password.',
        'auth/invalid-credential': 'Invalid email or password.',
        'auth/too-many-requests': 'Too many attempts. Please wait and try again.',
      };
      try {
        await writeAuditLog('pharmacy_002', { email, uid: 'unknown' }, {
          action: 'Login failed',
          entityType: 'auth',
          entityName: email,
          previousValue: '',
          newValue: err.code || 'unknown',
          source: 'client',
        });
      } catch (_) {}
      setError(msgs[err.code] || 'Sign in failed. Please try again.');
    }
    setLoading(false);
  };

  return (
    <div style={{
      minHeight: '100vh', background: '#F8FAFC',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      fontFamily: 'Inter, system-ui, sans-serif'
    }}>
      <div style={{
        background: '#fff', borderRadius: 16, padding: '48px 40px',
        width: 400, boxShadow: '0 4px 24px rgba(0,0,0,0.08)',
        border: '1px solid #E2E8F0'
      }}>
        {/* Logo */}
        <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 32 }}>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="48" height="48">
            <rect x="90" y="130" width="92" height="92" rx="20" fill="#1768C4"/>
            <rect x="210" y="130" width="92" height="92" rx="20" fill="#2D6FB7"/>
            <rect x="330" y="130" width="92" height="92" rx="20" fill="#4C9DDB"/>
            <rect x="90" y="250" width="92" height="92" rx="20" fill="#4FC3D6"/>
            <rect x="210" y="250" width="92" height="92" rx="20" fill="#8EDCE6"/>
            <rect x="330" y="250" width="92" height="92" rx="20" fill="#CFEFF5"/>
          </svg>
          <div>
            <div style={{ fontSize: 22, fontWeight: 800, color: '#0F172A', lineHeight: 1 }}>
              <span style={{ color: '#0F172A' }}>Blister</span>
              <span style={{ color: '#1768C4' }}>Flow</span>
            </div>
            <div style={{ fontSize: 10, color: '#94A3B8', letterSpacing: '0.1em', marginTop: 2 }}>
              BLISTER PACKAGING SOLUTIONS
            </div>
          </div>
        </div>

        <h2 style={{ margin: '0 0 4px', fontSize: 20, fontWeight: 700, color: '#0F172A' }}>
          Sign in
        </h2>
        <p style={{ margin: '0 0 28px', fontSize: 13, color: '#64748B' }}>
          Access your pharmacy dashboard
        </p>

        {error && (
          <div style={{
            background: '#FEF2F2', border: '1px solid #FECACA', borderRadius: 8,
            padding: '10px 14px', marginBottom: 20, fontSize: 13, color: '#DC2626'
          }}>
            {error}
          </div>
        )}

        <div onKeyDown={(e) => e.key === 'Enter' && handleSubmit(e)}>
          <div style={{ marginBottom: 16 }}>
            <label style={{ display: 'block', fontSize: 13, fontWeight: 500, color: '#374151', marginBottom: 6 }}>
              Email
            </label>
            <input type="email" value={email} onChange={e => setEmail(e.target.value)}
              placeholder="you@pharmacy.com"
              style={{
                width: '100%', padding: '10px 12px', border: '1px solid #D1D5DB',
                borderRadius: 8, fontSize: 14, color: '#0F172A', outline: 'none',
                boxSizing: 'border-box', background: '#F9FAFB'
              }} />
          </div>
          <div style={{ marginBottom: 24 }}>
            <label style={{ display: 'block', fontSize: 13, fontWeight: 500, color: '#374151', marginBottom: 6 }}>
              Password
            </label>
            <input type="password" value={password} onChange={e => setPassword(e.target.value)}
              placeholder="••••••••"
              style={{
                width: '100%', padding: '10px 12px', border: '1px solid #D1D5DB',
                borderRadius: 8, fontSize: 14, color: '#0F172A', outline: 'none',
                boxSizing: 'border-box', background: '#F9FAFB'
              }} />
          </div>
          <button onClick={handleSubmit} disabled={loading}
            style={{
              width: '100%', padding: '11px', background: loading ? '#94A3B8' : '#0F172A',
              color: '#fff', border: 'none', borderRadius: 8, fontSize: 14,
              fontWeight: 600, cursor: loading ? 'not-allowed' : 'pointer',
              transition: 'background 0.2s'
            }}>
            {loading ? 'Signing in…' : 'Sign in'}
          </button>
        </div>
      </div>
    </div>
  );
}
